import '@unocss/reset/tailwind.css'
import 'virtual:uno.css'
import '@/styles/main.css'
import { createPinia } from 'pinia'
import { createApp } from 'vue'
import App from './App.vue'
import globalComponents from './components'
import globalDirectives from './directives'
import router from './router'

const app = createApp(App)

app.use(createPinia())
app.use(router)
app.use(globalComponents)
app.use(globalDirectives)

app.mount('#app')
